import React from 'react';

import Tag from './AbstractTag';

Tag.parser.registerTag(
  'h3',
  class extends Tag {
    constructor(renderer, settings = {}) {
      super(renderer, settings);

      this.STRIP_OUTER = true;
    }

    toReact() {
      return <h3>{this.getComponents()}</h3>;
    }
  }
);
